import Vue from 'vue'

Vue.directive('onEnter', {
  bind: function (el, binding) {
    if (!binding.value) { return }
    el.addEventListener('keypress', ($event) => {
      if($event.which === 13){
        binding.value()
      } 
    })
  }
})